// extracted by mini-css-extract-plugin
export default {"root":"DotsMenuButton_root__nbEHB"};